<template>
  <div class="form-container card shadow-sm p-3">
    <!-- Cabeçalho -->
    <div class="header d-flex justify-content-between align-items-center">
      <h4 class="form-title">Nova Despesa</h4>
      <button class="btn btn-secondary" @click="cancelar">Voltar</button>
    </div>

    <div class="spacer"></div>

    <!-- Seção 1: Identificação da Despesa -->
    <div class="form-section">
      <h5 class="section-title">Identificação da Despesa</h5>
      <div class="row">
        <!-- Plano de Contas -->
        <div class="col-md-4">
          <div class="form-group">
            <label>Plano de Contas <span class="required">*</span></label>
            <select
              v-model.number="despesa.subconta"
              class="form-control"
              required
            >
              <option value="">Selecione</option>
              <option
                v-for="sc in subcontas"
                :key="sc.id"
                :value="sc.id"
              >
                {{ sc.nome }}
              </option>
            </select>
          </div>
        </div>

        <!-- Descrição -->
        <div class="col-md-8">
          <div class="form-group">
            <label>Descrição <span class="required">*</span></label>
            <input
              type="text"
              v-model="despesa.descricao"
              class="form-control"
              required
            />
          </div>
        </div>
      </div>
    </div>

    <div class="spacer"></div>

    <!-- Seção 2: Detalhes do Pagamento -->
    <div class="form-section">
      <h5 class="section-title">Detalhes do Pagamento</h5>
      <div class="row mb-3">
        <!-- Data do registro -->
        <div class="col-md-2">
          <div class="form-group">
            <label>Data do Registro</label>
            <input
              type="date"
              class="form-control disabled-input"
              :value="dataRegistro"
              disabled
            />
          </div>
        </div>
        <!-- Valor total -->
        <div class="col-md-2">
          <div class="form-group">
            <label>Valor Principal <span class="required">*</span></label>
            <input
              type="text"
              v-model="despesa._valorTotalEdit"
              @focus="onValorTotalFocus"
              @blur="onValorTotalBlur"
              inputmode="decimal"
              autocomplete="off"
              class="form-control"
              :class="{ 'is-invalid': despesa._valorTotalInvalid }"
              required
            />
          </div>
        </div>
        <!-- Recorrência (parcelas) -->
        <div class="col-md-1">
          <div class="form-group">
            <label>Recorrência</label>
            <input
              type="number"
              v-model.number="parcelasCount"
              class="form-control"
              min="1"
              required
            />
          </div>
        </div>

        <!-- Período -->
        <div class="col-md-3" v-if="parcelasCount > 1">
          <div class="form-group">
            <label>Período</label>
            <select
              v-model="despesa.periodicidade"
              class="form-control"
              required
            >
              <option value="mensal">Mensal (mesmo dia a cada mês)</option>
              <option value="quinzenal">Quinzenal (a cada 15 dias)</option>
              <option value="semanal">Semanal (a cada 7 dias)</option>
              <option value="outro">Outro período</option>
            </select>
          </div>
        </div>
        <!-- Informe período em dias -->
        <div class="col-md-3" v-if="parcelasCount > 1 && despesa.periodicidade === 'outro'">
          <label>Período (dias)</label>
          <input
            type="number"
            v-model.number="despesa.periodicidade_dias"
            class="form-control"
            min="1"
            required
          />
        </div>

        <!-- Primeiro vencimento -->
        <div class="col-md-2" v-if="parcelasCount > 1">
          <div class="form-group">
            <label>1º Vencimento <span class="required">*</span></label>
            <input
              type="date"
              v-model="despesa.primeiro_vencimento"
              class="form-control"
              required
            />
          </div>
        </div>
      </div>

      <!-- Tabela de pagamentos -->
      <div class="table-responsive" v-if="parcelasCount >= 1">
        <table class="table table-borderless">
          <thead>
            <tr>
              <th>#</th>
              <th>Forma de Pagamento <span class="required">*</span></th>
              <th>Vencimento <span class="required">*</span></th>
              <th>Pagamento</th>
              <th>Valor</th>
              <th v-if="pagamentos.some(isPagamentoEmAtraso)">Juros</th>
              <th v-if="pagamentos.some(isPagamentoEmAtraso)">Multa</th>
              <th>Desconto</th>
              <th>Total Pago</th>
              <!-- <th>Recebimento</th> -->
              <th>Conta Financeira <span class="required">*</span></th>
              <th v-if="showChequeCols">Banco nº</th>
              <th v-if="showChequeCols">Agência</th>
              <th v-if="showChequeCols">Cheque nº</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p, i) in pagamentos" :key="i">
              <td>{{ i + 1 }}</td>
              <td>
                <select
                  v-model.number="p.forma_pagamento_id"
                  @change="onParcelaChange(p)"
                  class="form-control"
                  required
                >
                  <option value="">Selecione</option>
                  <option v-for="fp in formasPagamento" :key="fp.id" :value="fp.id">
                    {{ fp.nome }}
                  </option>
                </select>
              </td>
              <td>
                <input
                  type="date"
                  v-model="p.data_vencimento"
                  @change="onParcelaChange(p)"
                  class="form-control"
                  required
                />
              </td>
              <td>
                <input
                  type="date"
                  v-model="p.data_pagamento"
                  @change="onParcelaChange(p)"
                  :disabled="isAInformar(p.forma_pagamento_id)"
                  class="form-control"
                />
              </td>
              <td>
                <input
                  type="text"
                  v-model="p._valorEdit"
                  @focus="onValorFocus(p)"
                  @blur="onValorBlur(p)"
                  inputmode="decimal"
                  autocomplete="off"
                  class="form-control"
                  :class="{ 'is-invalid': p._valorInvalid }"
                />
              </td>

              <td v-if="pagamentos.some(isPagamentoEmAtraso)">
                <template v-if="isPagamentoEmAtraso(p)">
                  <input
                    type="text"
                    v-model="p._jurosEdit"
                    @focus="onJurosFocus(p)"
                    @blur="onJurosBlur(p)"
                    inputmode="decimal"
                    autocomplete="off"
                    class="form-control"
                    :class="{ 'is-invalid': p._jurosInvalid }"
                  />
                </template>
              </td>
              <td v-if="pagamentos.some(isPagamentoEmAtraso)">
                <template v-if="isPagamentoEmAtraso(p)">
                  <input
                    type="text"
                    v-model="p._multaEdit"
                    @focus="onMultaFocus(p)"
                    @blur="onMultaBlur(p)"
                    inputmode="decimal"
                    autocomplete="off"
                    class="form-control"
                    :class="{ 'is-invalid': p._multaInvalid }"
                  />
                </template>
              </td>
              <td>
                <input
                  type="text"
                  v-model="p._descontoEdit"
                  @focus="onDescontoFocus(p)"
                  @blur="onDescontoBlur(p)"
                  inputmode="decimal"
                  autocomplete="off"
                  class="form-control"
                  :class="{ 'is-invalid': p._descontoInvalid }"
                />
              </td>
              <td>
                {{ formatBRL((Number(p.valor || 0) + Number(p.juros || 0) + Number(p.multa || 0) - Number(p.desconto || 0))) }}
              </td>

              <!-- <td>
                <input
                  type="date"
                  v-model="p.data_recebimento"
                  class="form-control"
                  disabled
                />
              </td> -->

              <td>
                <select
                  v-model.number="p.conta_financeira_id"
                  class="form-control"
                  :disabled="isAInformar(p.forma_pagamento_id)"
                  :required="!isAInformar(p.forma_pagamento_id) && !!(p.data_pagamento && p.data_pagamento.trim())"
                >
                  <!-- A informar -->
                  <option v-if="isAInformar(p.forma_pagamento_id)" :value="null">A informar</option>

                  <!-- Normal (inclui Espécie) -->
                  <template v-else>
                    <option :value="null" disabled>Selecione</option>
                    <option v-for="c in contasFinanceiras" :key="c.id" :value="c.id">
                      {{ c.texto }}
                    </option>
                  </template>
                </select>
              </td>

              <td v-if="showChequeCols">
                <input
                  v-if="p.forma_pagamento_id === idCheque"
                  v-model="p.banco_numero"
                  type="text"
                  class="form-control"
                  placeholder="Banco nº"
                  required
                />
              </td>
              <td v-if="showChequeCols">
                <input
                  v-if="p.forma_pagamento_id === idCheque"
                  v-model="p.agencia"
                  type="text"
                  class="form-control"
                  placeholder="Agência"
                  required
                />
              </td>
              <td v-if="showChequeCols">
                <input
                  v-if="p.forma_pagamento_id === idCheque"
                  v-model="p.cheque_numero"
                  type="text"
                  class="form-control"
                  placeholder="Cheque nº"
                  required
                />
              </td>

              <td>
                <i
                  class="bi bi-trash-fill text-danger"
                  title="Remover parcela"
                  @click="removerParcela(i)"
                  style="cursor: pointer;"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Ações -->
    <div class="form-actions d-flex justify-content-end">
      <button
        class="btn btn-primary me-2"
        :disabled="!formValid || isSubmitting"
        @click="salvar"
      >
        <i class="bi bi-save me-1"></i>
        {{ isSubmitting ? 'Salvando…' : 'Salvar' }}
      </button>
      <button
        class="btn btn-secondary"
        :disabled="isSubmitting"
        @click="cancelar"
      >
        <i class="bi bi-x-circle me-1"></i>
        Cancelar
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted } from 'vue';
import axios from '@/services/axios';
import Holidays from 'date-holidays';
import { useRouter } from 'vue-router';

const router = useRouter();
const hd = new Holidays('BR','DF');

// Estado principal
const despesa = reactive({
  id: null,
  subconta: null,
  descricao: '',
  criado_em: '',
  valor_total: '',
  _valorTotalEdit: '0,00',
  _valorTotalInvalid: false,
  periodicidade: 'mensal',
  periodicidade_dias: null,
  primeiro_vencimento: ''
});

// Controles
const subcontas = ref([]);
const formasPagamento = ref([]);
const contasFinanceiras = ref([]);
const pagamentos = ref([]);
const parcelasCount = ref(1);
const isSubmitting = ref(false);

// IDs e helpers (iguais ao modelo de receita)
const idAInformar = computed(() =>
  formasPagamento.value.find(fp => fp.nome.toLowerCase() === 'a informar')?.id || null
);
function isAInformar(formaId) {
  return formaId === idAInformar.value;
}
const idEspecie = computed(() =>
  formasPagamento.value.find(fp => fp.nome.toLowerCase() === 'espécie')?.id || null
);
const idCheque = computed(() =>
  formasPagamento.value.find(fp => fp.nome.toLowerCase() === 'cheque')?.id || null
);
const idPix = computed(() =>
  formasPagamento.value.find(f => f.nome.toLowerCase() === 'pix')?.id
);
const idTranfs = computed(() =>
  formasPagamento.value.find(f => f.nome.toLowerCase().includes('transferência'))?.id
);
function isFastPay(formaId) {
  return [idCheque.value, idPix.value, idEspecie.value, idTranfs.value].includes(formaId);
}
const showChequeCols = computed(() =>
  pagamentos.value.some(p => p.forma_pagamento_id === idCheque.value)
);

const isPagamentoEmAtraso = (pagamento) => {
  const venc = String(pagamento?.data_vencimento || '').trim();
  const pag = String(pagamento?.data_pagamento || '').trim();
  if (!venc || !pag) return false;
  return pag > venc;
};

function onValorFocus(p) {
  if (p?._valorEdit != null) {
    p._valorEdit = String(p._valorEdit).replace(/\./g, '');
  }
  p._valorInvalid = false;
}

function onValorBlur(p) {
  const parsed = parseBRL(p._valorEdit);
  if (parsed == null || parsed <= 0) {
    p._valorInvalid = true;
    return;
  }
  p._valorInvalid = false;
  p.valor = parsed;
  p._valorEdit = formatBRL(parsed);
}

function onJurosFocus(p) {
  if (p?._jurosEdit != null) {
    p._jurosEdit = String(p._jurosEdit).replace(/\./g, '');
  }
  p._jurosInvalid = false;
}

function onJurosBlur(p) {
  const parsed = parseBRL(p._jurosEdit);
  if (parsed == null || parsed < 0) {
    p._jurosInvalid = true;
    return;
  }
  p._jurosInvalid = false;
  p.juros = parsed;
  p._jurosEdit = formatBRL(parsed);
}

function onMultaFocus(p) {
  if (p?._multaEdit != null) {
    p._multaEdit = String(p._multaEdit).replace(/\./g, '');
  }
  p._multaInvalid = false;
}

function onMultaBlur(p) {
  const parsed = parseBRL(p._multaEdit);
  if (parsed == null || parsed < 0) {
    p._multaInvalid = true;
    return;
  }
  p._multaInvalid = false;
  p.multa = parsed;
  p._multaEdit = formatBRL(parsed);
}

function onDescontoFocus(p) {
  if (p?._descontoEdit != null) {
    p._descontoEdit = String(p._descontoEdit).replace(/\./g, '');
  }
  p._descontoInvalid = false;
}

function onDescontoBlur(p) {
  const parsed = parseBRL(p._descontoEdit);
  if (parsed == null || parsed < 0) {
    p._descontoInvalid = true;
    return;
  }
  p._descontoInvalid = false;
  p.desconto = parsed;
  p._descontoEdit = formatBRL(parsed);
}


function formatBRL(n) {
  const num = Number(n ?? 0);
  return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
function parseBRL(s) {
  if (s == null || s === '') return null;
  const num = parseFloat(String(s).replace(/\./g, '').replace(',', '.'));
  return Number.isFinite(num) ? Number(num.toFixed(2)) : null;
}

function onValorTotalFocus() {
  if (despesa._valorTotalEdit != null) {
    despesa._valorTotalEdit = String(despesa._valorTotalEdit).replace(/\./g, '');
  }
  despesa._valorTotalInvalid = false;
}

function onValorTotalBlur() {
  const parsed = parseBRL(despesa._valorTotalEdit);
  if (parsed == null || parsed <= 0) {
    despesa._valorTotalInvalid = true;
    return;
  }
  despesa._valorTotalInvalid = false;
  despesa.valor_total = parsed;
  despesa._valorTotalEdit = formatBRL(parsed);
}

function calcularDataRecebimento(vencimento, formaId) {
  if (!vencimento || !formaId) return '';
  const forma = formasPagamento.value.find(f => f.id === formaId);
  const nome  = (forma?.nome || '').toLowerCase();
  const dias =
    nome.includes('crédito') ? 31 :
    nome.includes('débito')   ? 1  :
    (forma?.prazo_pagamento || 0);
  const d0 = new Date(vencimento + 'T00:00:00');
  d0.setDate(d0.getDate() + dias);
  while ([0,6].includes(d0.getDay()) || hd.isHoliday(d0,'public')) {
    d0.setDate(d0.getDate() + 1);
  }
  return d0.toISOString().split('T')[0];
}

// Data do registro
const dataRegistro = computed(() =>
  (new Date()).toISOString().slice(0,10)
);

// Validação
const formValid = computed(() => {
  if (!despesa.subconta || !despesa.descricao) return false;
  if (!despesa.valor_total || parcelasCount.value < 1) return false;
  if (parcelasCount.value > 1 && !despesa.primeiro_vencimento) return false;

  return pagamentos.value.every(p => {
    if (!p.forma_pagamento_id || !p.data_vencimento) return false;

    // "A informar" → não exige conta nem data_pagamento
    if (isAInformar(p.forma_pagamento_id)) return true;

    // Demais (inclui "Espécie"):
    // Se informou data_pagamento → exige conta
    if ((p.data_pagamento || '').trim() && !p.conta_financeira_id) return false;

    // Cheque com pagamento informado → exige dados do cheque
    if (p.forma_pagamento_id === idCheque.value && (p.data_pagamento || '').trim()) {
      if (!p.banco_numero || !p.agencia || !p.cheque_numero) return false;
    }

    return true;
  });
});

// function formatCurrency(v) {
//   return Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
// }

function addMonthsSameDay(yyyyMmDd, monthsToAdd) {
  // Evita drift de timezone usando sempre UTC
  const [y, m, d] = yyyyMmDd.split('-').map(Number);
  // 1) apontamos para o primeiro dia do mês base em UTC
  const firstOfBase = new Date(Date.UTC(y, m - 1, 1));
  // 2) último dia do mês de destino
  const lastOfTarget = new Date(Date.UTC(firstOfBase.getUTCFullYear(), firstOfBase.getUTCMonth() + monthsToAdd + 1, 0));
  // 3) preserva o mesmo dia, limitado ao último do mês de destino
  const day = Math.min(d, lastOfTarget.getUTCDate());
  const result = new Date(Date.UTC(firstOfBase.getUTCFullYear(), firstOfBase.getUTCMonth() + monthsToAdd, day));
  // retorna 'YYYY-MM-DD' (UTC)
  return result.toISOString().slice(0, 10);
}


function gerarPagamentos(count) {
  const fmt = (n) => Number(n ?? 0).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const valorParcela = Number(despesa.valor_total) || 0;
  const primeiroVenc = despesa.primeiro_vencimento || dataRegistro.value;

  const arr = [];
  const nParcelas = Math.max(0, Number(count) || 0);

  for (let i = 0; i < nParcelas; i++) {
    let dataCalculada;

    if (despesa.periodicidade === 'mensal') {
      // >>> MÊS A MÊS, MESMO DIA (limitado ao fim do mês, ex.: 31 -> 30/28/29)
      dataCalculada = addMonthsSameDay(primeiroVenc, i);
    } else {
      // >>> Demais períodos continuam por dias fixos
      let dias = 30;
      switch (despesa.periodicidade) {
        case 'quinzenal': dias = 15; break;
        case 'semanal':   dias = 7;  break;
        case 'outro':     dias = Number(despesa.periodicidade_dias) || 1; break;
      }
      const d0 = new Date(primeiroVenc + 'T00:00:00');
      d0.setDate(d0.getDate() + (i * dias));
      dataCalculada = d0.toISOString().slice(0, 10);
    }

    // >>> NENHUM ajuste para sábado/domingo/feriado

    arr.push({
      id: null,
      despesas_id: null,
      forma_pagamento_id: idAInformar.value ?? null,
      data_vencimento: dataCalculada,
      valor: valorParcela,
      juros: 0,
      multa: 0,
      desconto: 0,
      _valorTotalPago: valorParcela,
      _valorEdit: fmt(valorParcela),
      _valorInvalid: false,
      _jurosEdit: fmt(0),
      _jurosInvalid: false,
      _multaEdit: fmt(0),
      _multaInvalid: false,
      _descontoEdit: fmt(0),
      _descontoInvalid: false,
      data_pagamento: '',
      data_recebimento: '',
      conta_financeira_id: null,
      banco_numero: '',
      agencia: '',
      cheque_numero: ''
    });
  }

  pagamentos.value = arr;
}

watch(
  [
    parcelasCount,
    () => despesa.valor_total,
    () => despesa.periodicidade,
    () => despesa.periodicidade_dias,
    () => despesa.primeiro_vencimento
  ],
  () => {
    despesa.parcelas = parcelasCount.value;
    if (parcelasCount.value >= 1) {
      if (!despesa.primeiro_vencimento) despesa.primeiro_vencimento = dataRegistro.value;
      gerarPagamentos(parcelasCount.value);
    }
  }
);

function onParcelaChange(p) {
  const nome = (formasPagamento.value.find(f => f.id===p.forma_pagamento_id)?.nome || '').toLowerCase();
  if (nome==='a informar') p.data_pagamento = '';
  else if (!p.data_pagamento) p.data_pagamento = p.data_vencimento;
  // recebimento
  if (!p.data_pagamento) p.data_recebimento = '';
  else if (isFastPay(p.forma_pagamento_id)) p.data_recebimento = p.data_pagamento;
  else p.data_recebimento = calcularDataRecebimento(p.data_pagamento, p.forma_pagamento_id) || '';
}

// FormularioDespesas.vue
async function carregarListas() {
  const respSc = await axios.get('/financeiro/subcontas', {
    params: {
      tipo: 'Despesa',
      ativo: 'true',
      sortField: 'nome',
      sortOrder: 'asc',
      limit: 'all',     // agora suportado pelo backend
    },
  });
  const norm = s =>
    String(s || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();

  subcontas.value = (respSc.data.data || []).filter(
    sc => norm(sc.nome) !== 'taxas da operadora'
  );

  const respCf = await axios.get('/financeiro/contas-financeiras');
  contasFinanceiras.value = respCf.data.data.map(c => ({
    id: c.id,
    texto: `${c.apelido} | Ag ${c.agencia} | CC ${c.numero_conta}`,
  }));

  await carregarFormas();
}

async function carregarFormas() {
  try {
    const res = await axios.get('/cadastros/formas-pagamento');
    const items = (res.data?.data ?? res.data) || [];

    formasPagamento.value = items
      .filter(f => (f.nome || '').toLowerCase() !== 'brinde')
      .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' }));
  } catch (e) {
    console.error('Erro ao carregar formas de pagamento:', e);
  }
}

async function salvar() {
  if (!formValid.value) return;
  isSubmitting.value = true;

  const payload = {
    subconta: despesa.subconta,
    descricao: despesa.descricao,
    valor_total: despesa.valor_total,
    parcelas: parcelasCount.value,
    periodicidade: despesa.periodicidade,
    periodicidade_dias: despesa.periodicidade === 'outro' ? despesa.periodicidade_dias : null,
    primeiro_vencimento: despesa.primeiro_vencimento,
    pagamentos: pagamentos.value.map(p => ({
      forma_pagamento_id: p.forma_pagamento_id,
      data_vencimento: p.data_vencimento,
      valor: p.valor,
      juros: p.juros || 0,
      multa: p.multa || 0,
      desconto: p.desconto || 0,
      data_pagamento: p.data_pagamento || null,
      data_recebimento: p.data_recebimento || null,
      conta_financeira_id: p.conta_financeira_id || null,
      banco_numero: p.banco_numero || null,
      agencia: p.agencia || null,
      cheque_numero: p.cheque_numero || null
    }))
  };

  try {
    await axios.post('/financeiro/despesas', payload);
    router.push('/financeiro/despesas');
  } catch (err) {
    console.error(err);
    alert('Erro ao salvar despesa');
  } finally {
    isSubmitting.value = false;
  }
}

function removerParcela(i){ pagamentos.value.splice(i,1); parcelasCount.value=pagamentos.value.length; }

function cancelar(){ router.push('/financeiro/despesas'); }

onMounted(async () => {
  await carregarListas();
  despesa.criado_em = new Date().toISOString();
  despesa.primeiro_vencimento = dataRegistro.value;
  despesa._valorTotalEdit = formatBRL(Number(despesa.valor_total || 0));
  gerarPagamentos(parcelasCount.value);
});
</script>

<style scoped>
.spacer {
  margin-bottom: 1rem;
}
.section-title {
  font-weight: bold;
  margin-bottom: 0.5rem;
}
.required {
  color: red;
}
.disabled-input {
  background: #e9ecef;
}
.form-actions {
  margin-top: 1.5rem;
}

/* Layout similar ao FormSection do formulário de Aula Avulsa */
.form-section {
  background: white;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  margin-bottom: 1rem;
}

/* Títulos das seções */
.section-title {
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 10px;
}

/* Estilização para campos desativados */
.disabled-input {
  background: #e9ecef;
  border: 1px solid #ced4da;
}

/* Ícones de ação */
.required {
  color: red;
}
</style>
